import {NgModule} from '@angular/core';
import {PagesSharedModule} from '../../../pages/pages-shared.module';
import {OwnershipSelectComponent} from './ownership-select.component';
import {SimpleSelectModule} from '../base-select/simple-select/simple-select.module';

@NgModule({
    imports: [
        PagesSharedModule,
        SimpleSelectModule
    ],
    declarations: [
        OwnershipSelectComponent
    ],
    entryComponents: [],
    exports: [
        OwnershipSelectComponent
    ]
})
export class OwnershipSelectModule {
}
